import React from 'react'
import $ from 'jquery'
import _ from 'lodash'
import classNames from 'classnames'
import PropTypes from 'prop-types';
import Misc from '../../misc';

class UIDropDown extends React.PureComponent {
  constructor(props) {
    super(props);

    let values = props.values || [];
    if(typeof(values[0]) == "object") {
      values.sort((a, b) => {
        let _a = _.trim(a.text).toLowerCase();
        let _b = _.trim(b.text).toLowerCase();
        if(a.value == -1 || a.value == "<") {
          return -1;
        } else if (b.value == -1 || b.value == "<") {
          return 1;
        } else if (_a < _b) {
          return -1;
        } else if (_a > _b) {
          return 1;
        }
        return 0;
      });
    } else {
      values.sort((a,b) => {
        let _a = _.trim(a).toLowerCase();
        let _b = _.trim(b).toLowerCase();
        if(_a < _b)
          return -1;
        else if(_a > _b)
          return 1;
        return 0;
      });
    }
    let selected = props.value || values[0] || null;
    let selectedText = selected;

    if(typeof(selected) != "object" && typeof(values[0]) == "object") {
      selected = _.find(values, v => v.value == selected);
    }

    if(typeof(selected) == "object") {
      selectedText = selected.text;
      selected = selected.value;
    }

    this.state = {
      isOpen: false,
      selectedValue: selected,
      selectedText,
      values,
      filteredValues: values,
      filter: ""
    }
    if(this.props.onChange)
      this.props.onChange(selected.value || selected);
  }

  handleValueChanged = (value) => {
    if(this.props.onChange)
      this.props.onChange(value.value || value);

    let selectedValue = value;
    if(typeof(selectedValue) == "object") {
      this.setState({
        selectedText: selectedValue.text,
        selectedValue: selectedValue.value
      });
    } else {
      this.setState({
        selectedValue,
        selectedText: selectedValue
      });
    }
  }

  handleClick = () => {
    this.setState({isOpen: !this.state.isOpen, filter: "", filteredValues: this.getFilteredValues("")}, () => {
      if(this.state.isOpen) {
        let el = $(this.dropDownElement);
        let parent = el.parents('.ui-select');
        let parentOffset = parent.offset();
        let containerOffset = el.parents('.job-board-message-container').offset();

        if(parentOffset && containerOffset) {
          let offset = {
            top: parentOffset.top - containerOffset.top,
            left: parentOffset.left - containerOffset.left
          }
          $(this.dropDownElement).css({
            top: offset.top,
            left: offset.left,
            width: parent.width(),
            minWidth: 'auto',
            position: 'fixed'
          }).focus();
        }
      }
    });
  }

  getDropDownOptions = () => _.map(this.state.filteredValues, val => {
    let value = val;
    let text = val;
    if (typeof(val) == "object") {
      value = val.value;
      text = val.text;
    }
    if(this.state.selectedValue != value) {
      return (
        <div
          className={classNames("ui-select-dropdown__option")}
          onClick={this.handleValueChanged.bind(this, val)} key={value}
        >{text}</div>
      );
    }
  });

  getFilteredValues = (filter) => {
    let _filter = _.trim(filter).toLowerCase();
    let filteredValues = this.state.values;
    if(_filter.length > 0) {
      if(typeof(this.state.values[0]) == "object") {
        filteredValues = this.state.values.filter(_ => _.text.toLowerCase().includes(_filter));
      } else {
        filteredValues = this.state.values.filter(_ => _.toLowerCase().includes(_filter));
      }
    }
    return filteredValues;
  }

  handleFilterChange = (e) => {
    Misc.ignoreDefault(e);
    this.setState({filter: e.target.value, filteredValues: this.getFilteredValues(e.target.value)});
  }

  render() {
    return (
      <div className={classNames("ui-select ui-select--2", {'ui-select--wide ui-select--large': this.props.wide, "ui-select--green": this.props.green})} onClick={this.handleClick}>
        <div className="ui-select-button"></div>
        <div className={classNames("ui-select-container",{"ui-select-container--opened":this.state.isOpen})}>
          <span className="ui-select-text">{this.state.selectedText}</span>
          {this.state.isOpen ? (
            <div className={classNames(this.state.isOpen ? 'ui-select-dropdown--opened' : 'ui-select-dropdown')} ref={(node) => this.dropDownElement = node} onBlur={this.handleClick}>
              {this.state.values.length > 10 ?
                <input value={this.state.filter}
                  onChange={this.handleFilterChange}
                  onClick={Misc.ignoreDefault}
                  placeholder="Filter Values..."
                  className="ui-input ui-input--blue" />
                : null }
              <div
                  className={classNames("ui-select-dropdown__option--selected")}
                >{this.state.selectedText}</div>
              {this.getDropDownOptions()}
            </div>
          ) : null}
        </div>
      </div>
    )
  };
};

UIDropDown.propTypes = {
  values: PropTypes.array.isRequired,
  value: PropTypes.oneOfType([PropTypes.object, PropTypes.string]),
  onChange: PropTypes.func.isRequired
};

export default UIDropDown;
export { UIDropDown };
